import Vue from 'vue'
import VueRouter from 'vue-router'
import login from "@/views/login";
import index from "@/views/index"
import Router from "vue-router";
import home from "@/views/home/home-new";
import Detail from '@/views/aged/aged_detail'



Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'login',
        component: login,
        hidden:true
    },{
        path: '/index',
        name: 'index',
        component: index,
        children:[
            {
                path: '/home/home-new',
                name: 'Home',
                component: home,
                meta:{
                    keepAlive: true
                }
            },
            {
                path: '/aged/aged_detail',
                name: 'detail',
                component: resolve => require(['@/views/aged/aged_detail'],resolve)

            },
            // HDCS测试页面
            {
                path: '/device/hdcs_test',
                name: 'hdcs_test',
                component: resolve => require(['@/views/device/hdcs_test'],resolve),
                meta:{
                    title: 'HDCS测试',
                    keepAlive: false
                }
            },
            // HDCS模拟器页面
            {
                path: '/device/hdcs_simulator',
                name: 'hdcs_simulator',
                component: resolve => require(['@/views/device/hdcs_simulator'],resolve),
                meta:{
                    title: 'HDCS模拟器',
                    keepAlive: false
                }
            }

        ],
    },{
        path: '/manageV',
        name: 'manageV',
        component: resolve => require(['@/views/im/Manage'],resolve),
        meta:{
            title: '工作人员',
            keepAlive: false
        }
    },{
        path: '/ageV',
        name: 'ageV',
        component: resolve => require(['@/views/im/Age'],resolve),
        meta:{
            title: '老人',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_100',
        name: 'report_big_screen_100',
        component: resolve => require(['@/views/report/report_big_screen_100'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_105',
        name: 'report_big_screen_105',
        component: resolve => require(['@/views/report/report_big_screen_105'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_21',
        name: 'report_big_screen_21',
        component: resolve => require(['@/views/report/report_big_screen_21'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_15',
        name: 'report_big_screen_15',
        component: resolve => require(['@/views/report/report_big_screen_15'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_20',
        name: 'report_big_screen_20',
        component: resolve => require(['@/views/report/report_big_screen_20'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_22',
        name: 'report_big_screen_22',
        component: resolve => require(['@/views/report/report_big_screen_22'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_50',
        name: 'report_big_screen_50',
        component: resolve => require(['@/views/report/report_big_screen_50'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_14',
        name: 'report_big_screen_14',
        component: resolve => require(['@/views/report/report_big_screen_14'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_26',
        name: 'report_big_screen_26',
        component: resolve => require(['@/views/report/report_big_screen_26'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_27',
        name: 'report_big_screen_27',
        component: resolve => require(['@/views/report/report_big_screen_27'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_28',
        name: 'report_big_screen_28',
        component: resolve => require(['@/views/report/report_big_screen_28'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    }, {
        path: '/report/report_big_screen_2',
        name: 'report_big_screen_2',
        component: resolve => require(['@/views/report/report_big_screen_2'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_25',
        name: 'report_big_screen_25',
        component: resolve => require(['@/views/report/report_big_screen_25'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_51',
        name: 'report_big_screen_51',
        component: resolve => require(['@/views/report/report_big_screen_51'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_52',
        name: 'report_big_screen_52',
        component: resolve => require(['@/views/report/report_big_screen_52'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_53',
        name: 'report_big_screen_53',
        component: resolve => require(['@/views/report/report_big_screen_53'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_54',
        name: 'report_big_screen_54',
        component: resolve => require(['@/views/report/report_big_screen_54'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_60',
        name: 'report_big_screen_60',
        component: resolve => require(['@/views/report/report_big_screen_60'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_24',
        name: 'report_big_screen_24',
        component: resolve => require(['@/views/report/report_big_screen_24'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_29',
        name: 'report_big_screen_29',
        component: resolve => require(['@/views/report/report_big_screen_29'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_30',
        name: 'report_big_screen_30',
        component: resolve => require(['@/views/report/report_big_screen_30'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_61',
        name: 'report_big_screen_61',
        component: resolve => require(['@/views/report/report_big_screen_61'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_55',
        name: 'report_big_screen_55',
        component: resolve => require(['@/views/report/report_big_screen_55'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_1',
        name: 'report_big_screen_1',
        component: resolve => require(['@/views/report/report_big_screen_1'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_3',
        name: 'report_big_screen_3',
        component: resolve => require(['@/views/report/report_big_screen_3'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_4',
        name: 'report_big_screen_4',
        component: resolve => require(['@/views/report/report_big_screen_4'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_56',
        name: 'report_big_screen_56',
        component: resolve => require(['@/views/report/report_big_screen_56'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_57',
        name: 'report_big_screen_57',
        component: resolve => require(['@/views/report/report_big_screen_57'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/screen',
        name: 'screen_all',
        component: resolve => require(['@/views/screen/ScreenShow'],resolve),
        meta:{
            title: '智慧养老大数据管理平台',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/aged_map',
        name: 'aged_map',
        component: resolve => require(['@/views/report/bigDate/aged_map'],resolve),
        meta:{
            title: '长者大数据地图',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/aged_date',
        name: 'aged_date',
        component: resolve => require(['@/views/report/bigDate/aged_date'],resolve),
        meta:{
            title: '长者大数据',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/health_record',
        name: 'health_record',
        component: resolve => require(['@/views/report/bigDate/health_record'],resolve),
        meta:{
            title: '长者健康大数据',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/bed_transform',
        name: 'bed_transform',
        component: resolve => require(['@/views/report/bigDate/bed_transform'],resolve),
        meta:{
            title: '家庭养老床位大数据',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/door_service',
        name: 'door_service',
        component: resolve => require(['@/views/report/bigDate/door_service'],resolve),
        meta:{
            title: '上门服务大数据',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/fuwu_map',
        name: 'fuwu_map',
        component: resolve => require(['@/views/report/bigDate/fuwu_map'],resolve),
        meta:{
            title: '服务大数据地图',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/bed_map',
        name: 'bed_map',
        component: resolve => require(['@/views/report/bigDate/bed_map'],resolve),
        meta:{
            title: '床位改造大数据地图',
            keepAlive: false
        }
    }, {
        path: '/report/bigDate/anfang_map',
        name: 'anfang_map',
        component: resolve => require(['@/views/report/bigDate/anfang_map'],resolve),
        meta:{
            title: '安防设备大数据地图',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/chuangdian_map',
        name: 'chuangdian_map',
        component: resolve => require(['@/views/report/bigDate/chuangdian_map'],resolve),
        meta:{
            title: '床垫大数据地图',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/leidabo_map',
        name: 'leidabo_map',
        component: resolve => require(['@/views/report/bigDate/leidabo_map'],resolve),
        meta:{
            title: '雷达波大数据地图',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/shouhuan_map',
        name: 'shouhuan_map',
        component: resolve => require(['@/views/report/bigDate/shouhuan_map'],resolve),
        meta:{
            title: '手环大数据地图',
            keepAlive: false
        }
    },
    {
        path: '/report/bigDate/newShouhuan',
        name: 'newShouhuan',
        component: resolve => require(['@/views/report/bigDate/newShouhuan'],resolve),
        meta:{
            title: '手环大数据地图',
            keepAlive: false
        }
    },
    {
        path: '/report/bigDate/yunxinxiongka',
        name: 'yunxinxiongka',
        component: resolve => require(['@/views/report/bigDate/yunxinxiongka'],resolve),
        meta:{
            title: '胸卡大数据地图',
            keepAlive: false
        }
    },
    {
        path: '/aotong/full_screen',
        name: 'full_screen',
        component: resolve => require(['@/views/aotong/full_screen'],resolve),
        meta:{
            title: '火柴人监控全屏',
            keepAlive: false
        }
    },
    {
        path: '/report/bigDate/shengming_Radar',
        name: 'shengming_Radar',
        component: resolve => require(['@/views/report/bigDate/shengming_Radar'],resolve),
        meta:{
            title: '生命雷达波大数据地图',
            keepAlive: false
        },
    },
    {
        path: '/h5/my',
        name: 'my',
        component: resolve => require(['@/views/h5/my'], resolve),
        meta: {
            title: '我的',
            keepAlive: false
        },
    },
    {
        path: '/h5/service',
        name: 'service',
        component: resolve => require(['@/views/h5/service'], resolve),
        meta: {
            title: '工单',
            keepAlive: false
        },
    },
    {
        path: '/report/report_big_screen_58',
        name: 'report_big_screen_58',
        component: resolve => require(['@/views/report/report_big_screen_58'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },
    {
        path: '/report/wx_report/report_1',
        name: 'report_1',
        component: resolve => require(['@/views/report/wx_report/report_1'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },
    {
        path: '/report/wx_report/report_2',
        name: 'report_2',
        component: resolve => require(['@/views/report/wx_report/report_2'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },
    {
        path: '/report/wx_report/report_3',
        name: 'report_3',
        component: resolve => require(['@/views/report/wx_report/report_3'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/wx_report/report_4',
        name: 'report_4',
        component: resolve => require(['@/views/report/wx_report/report_4'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/big_aged',
        name: 'big_aged',
        component: resolve => require(['@/views/report/xiangqing/big_aged'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/big_gai_zhao',
        name: 'big_gai_zhao',
        component: resolve => require(['@/views/report/xiangqing/big_gai_zhao'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/ji_gou_lie_biao',
        name: 'ji_gou_lie_biao',
        component: resolve => require(['@/views/report/xiangqing/ji_gou_lie_biao'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/ji_gou_xiang_qing',
        name: 'ji_gou_xiang_qing',
        component: resolve => require(['@/views/report/xiangqing/ji_gou_xiang_qing'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/big_shang_men_fu_wu',
        name: 'big_shang_men_fu_wu',
        component: resolve => require(['@/views/report/xiangqing/big_shang_men_fu_wu'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/di_bao',
        name: 'di_bao',
        component: resolve => require(['@/views/report/xiangqing/di_bao'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/gao_ning',
        name: 'gao_ning',
        component: resolve => require(['@/views/report/xiangqing/gao_ning'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_200',
        name: 'report_big_screen_200',
        component: resolve => require(['@/views/report/report_big_screen_200'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/yongai/ji_gou_lie_biao',
        name: 'ji_gou_biao',
        component: resolve => require(['@/views/report/yongai/ji_gou_lie_biao'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/yongai/ji_gou_xiang_qing',
        name: 'ji_gou_xiang',
        component: resolve => require(['@/views/report/yongai/ji_gou_xiang_qing'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/big_gai_zhao_ty',
        name: 'xiangqing/big_gai_zhao_ty',
        component: resolve => require(['@/views/report/xiangqing/big_gai_zhao_ty'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_201',
        name: 'report_big_screen_201',
        component: resolve => require(['@/views/report/report_big_screen_201'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_202',
        name: 'report_big_screen_202',
        component: resolve => require(['@/views/report/report_big_screen_202'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/aged_info',
        name: 'aged_info',
        component: resolve => require(['@/views/report/xiangqing/aged_info'],resolve),
        meta:{
            title: '长者详情',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/aged_shen_qing',
        name: 'aged_shen_qing',
        component: resolve => require(['@/views/report/xiangqing/aged_shen_qing'],resolve),
        meta:{
            title: '服务申请',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_80',
        name: 'report_big_screen_80',
        component: resolve => require(['@/views/report/report_big_screen_80'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_82',
        name: 'report_big_screen_82',
        component: resolve => require(['@/views/report/report_big_screen_82'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_81',
        name: 'report_big_screen_81',
        component: resolve => require(['@/views/report/report_big_screen_81'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_6',
        name: 'report_big_screen_6',
        component: resolve => require(['@/views/report/report_big_screen_6'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/aged/tfga',
        name: 'tfga',
        component: resolve => require(['@/views/report/aged/tfga'],resolve),
        meta:{
            title: '探访关爱',
            keepAlive: false
        }
    },{
        path: '/report/aged/slh_aged_wx',
        name: 'slh_aged_wx',
        component: resolve => require(['@/views/report/aged/slh_aged_wx'],resolve),
        meta:{
            title: '改造档案',
            keepAlive: false
        }
    },{
        path: '/report/aged/slh_aged_pg_wx',
        name: 'slh_aged_pg_wx',
        component: resolve => require(['@/views/report/aged/slh_aged_pg_wx'],resolve),
        meta:{
            title: '改造档案',
            keepAlive: false
        }
    },
    {
        path: '/report/aged/wechat_IdCard',
        name: 'wechat_IdCard',
        component: resolve => require(['@/views/report/aged/wechat_IdCard'],resolve),
        meta:{
            title: '智能胸卡',
            keepAlive: false
        }
    },
    {
        path: '/report/aged/wechat_shouhuan',
        name: 'wechat_shouhuan',
        component: resolve => require(['@/views/report/aged/wechat_shouhuan'],resolve),
        meta:{
            title: '智能手环',
            keepAlive: false
        }
    },
    {
        path: '/report/aged/wechat_XueYaYi',
        name: 'wechat_XueYaYi',
        component: resolve => require(['@/views/report/aged/wechat_XueYaYi'],resolve),
        meta:{
            title: '血压仪',
            keepAlive: false
        }
    },
    {
        path: '/report/aged/wechat_XueTangYi',
        name: 'wechat_XueTangYi',
        component: resolve => require(['@/views/report/aged/wechat_XueTangYi'],resolve),
        meta:{
            title: '血糖仪',
            keepAlive: false
        }
    },
    {
        path: '/qinglanradar/multifunctionRadarStart',
        name: 'multifunctionRadarStart',
        component: resolve => require(['@/views/qinglanradar/multifunctionRadarStart'],resolve),
        meta:{
            title: '多功能雷达波',
            keepAlive: false
        }
    },
    {
        path: '/healthentiretyequipment/showHealthEquipment',
        name: 'showHealthEquipment',
        component: resolve => require(['@/views/healthentiretyequipment/showHealthEquipment'],resolve),
        meta:{
            title: '健康一体机健康数据',
            keepAlive: false
        }
    },
    {
        path: '/report/aged/wechat_whiteList',
        name: 'wechat_whiteList',
        component: resolve => require(['@/views/report/aged/wechat_whiteList'],resolve),
        meta:{
            title: '白名单设置',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_accessControl',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_accessControl'],resolve),
        meta:{
            title: '门禁开控制',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_healthAbility_img',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_healthAbility_img'],resolve),
        meta:{
            title: '能力评估图片上传',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_fourSoS_Phone',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_fourSoS_Phone'],resolve),
        meta:{
            title: '4gSoS电话设置',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_YunXinSOS',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_YunXinSOS'],resolve),
        meta:{
            title: '云心SoS设置',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_TumbleRadar',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_TumbleRadar'],resolve),
        meta:{
            title: '新版雷达波绑定',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_XingMai',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_XingMai'],resolve),
        meta:{
            title: '血压折线图',
            keepAlive: false
        }
    },{
        path: '/vr/vrConfig/:id',
        component: () => import('@/views/vr/vrExhibition/config'),
        meta:{
            title: '场景配置',
            keepAlive: false
        }
    },{
        path: '/vr/vrPreview/:id',
        component: () => import('@/views/vr/vrExhibition/preview'),
        meta:{
            title: '场景预览',
            keepAlive: false
        }
    },{
        path: '/vr/vrScenePreview/:id',
        component: () => import('@/views/vr/vrScene/preview'),
        meta:{
            title: '场景预览',
            keepAlive: false
        }
    }, {
        path: '/vr/vrWay',
        component: () => import('@/views/vr/vrExhibition/way'),
        meta: {
            title: '轨迹漫游',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_agedResidence',
        name: 'wechat_agedResidence',
        component: resolve => require(['@/views/report/aged/wechat_agedResidence'],resolve),
        meta:{
            title: '住宅管理',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_agedDelivery',
        name: 'wechat_agedDelivery',
        component: resolve => require(['@/views/report/aged/wechat_agedDelivery'],resolve),
        meta:{
            title: '送货管理',
            keepAlive: false
        }
    },{
        path: '/call/test',
        name: 'call/test',
        component: resolve => require(['@/views/call/test'],resolve),
        meta:{
            title: '护士台',
            keepAlive: false
        }
    },{
        path: '/kasnshituIpad',
        name: 'kasnshituIpad',
        component: resolve => require(['@/views/kasn/kasnshituIpad.vue'],resolve),
        meta:{
            title: '定位',
            keepAlive: false
        }
    },{
        path: '/report/pg/stay_assessment',
        name: 'stay_assessment',
        component: resolve => require(['@/views/report/pg/stay_assessment.vue'],resolve),
        meta:{
            title: '待评估',
            keepAlive: false
        }
    },{
        path: '/report/pg/ability_assessment2022',
        name: 'ability_assessment2022',
        component: resolve => require(['@/views/report/pg/ability_assessment2022.vue'],resolve),
        meta:{
            title: '能力评估',
            keepAlive: false
        }
    },{
        path: '/report/pg/member_upd',
        name: 'member_upd',
        component: resolve => require(['@/views/report/pg/member_upd.vue'],resolve),
        meta:{
            title: '会员编辑',
            keepAlive: false
        }
    },{
        path: '/wechat/login',
        name: 'login',
        component: resolve => require(['@/views/wechat/login.vue'],resolve),
        meta:{
            title: '登录',
            keepAlive: false
        }
    },{
        path: '/supplyChain/productNEW',
        name: 'productNEW',
        component: resolve => require(['@/views/supplyChain/productNEW'],resolve),
        meta:{
            title: '产品详情页面',
            keepAlive: false
        }
    },{
        path: '/game',
        name: 'gameIndex',
        component: resolve => require(['@/views/exam/GameIndex'],resolve),
        meta:{
            title: '产品详情页面',
            keepAlive: false
        }
    },{
        path: '/login2',
        name: 'login2',
        component: resolve => require(['@/views/login2.vue'],resolve),
        meta:{
            title: '登陆页',
            keepAlive: false
        }
    },{
        path: '/monitor/camera_h5',
        name: 'camera_h5',
        component: resolve => require(['@/views/monitor/camera_h5'],resolve),
        meta:{
            title: '机器人巡房',
            keepAlive: false
        }
    },{
        path: '/app/index',
        name: 'index',
        component: resolve => require(['@/views/app/index'],resolve),
        meta:{
            title: 'APP首页',
            keepAlive: false
        }
    },{
        path: '/app/aged',
        name: 'aged',
        component: resolve => require(['@/views/app/aged'],resolve),
        meta:{
            title: 'APP长者档案',
            keepAlive: false
        }
    },{
        path: '/app/assessment_pg',
        name: 'assessment_pg',
        component: resolve => require(['@/views/app/assessment_pg'],resolve),
        meta:{
            title: 'APP能力评估',
            keepAlive: false
        }
    },{
        path: '/app/cognitive_assessment',
        name: 'cognitive_assessment',
        component: resolve => require(['@/views/exam/jiqirenui/CognitiveAssessment'],resolve),
        meta:{
            title: '认知评估',
            keepAlive: false
        }
    },{
        path: '/app/cognitive_training',
        name: 'cognitive_training',
        component: resolve => require(['@/views/exam/jiqirenui/CognitiveTraining'],resolve),
        meta:{
            title: '认知训练',
            keepAlive: false
        }
    },{
        path: '/app/scale_assessment',
        name: 'scale_assessment',
        component: resolve => require(['@/views/exam/jiqirenui/ScaleAssessment'],resolve),
        meta:{
            title: '量表评定',
            keepAlive: false
        }
    },{
        path: '/app/login',
        name: 'login',
        component: resolve => require(['@/views/app/login'],resolve),
        meta:{
            title: 'APP登陆',
            keepAlive: false
        }
    },{
        path: '/bdsxt/token',
        name: 'login',
        component: resolve => require(['@/views/bdsxt/token'],resolve),
        meta:{
            title: '本地录像',
            keepAlive: false
        }
    },{
        path: '/ai/ai_evaluation_table',
        name: 'ai_evaluation_table',
        component: resolve => require(['@/views/ai/ai_evaluation_table.vue'],resolve),
        meta:{
            title: '评估表',
            keepAlive: false
        }
    },{
        path: '/ai/ai_evaluation_room_camera',
        name: 'ai_evaluation_room_camera',
        component: resolve => require(['@/views/ai/ai_evaluation_room_camera.vue'],resolve),
        meta:{
            title: '摄像头',
            keepAlive: false
        }
    }


]

// const createRouter = () =>
//     new VueRouter({
//       mode: 'history', // 去掉url中的#
//       scrollBehavior: () => ({ y: 0 }),
//       routes
//     });
//
// const router = createRouter();

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}


// // 定义一个resetRouter 方法，在退出登录时，调用即可
// export function resetRouter() {
//   const newRouter = createRouter();
//   router.matcher = newRouter.match();
// }

const router  = new VueRouter({
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({ y: 0 }),
    routes
})





export default router
